import {Predicate} from "../../../../types/GenericTypes";
import {ClientRiskRow, RiskRow} from "../risk-model/RiskSummary";
import {escapeRegExp} from "../../../../js/util/UtilFunctions";

export interface NameFilter {
    groupFilter: Predicate<RiskRow>;
    clientFilter: Predicate<ClientRiskRow>;
}

export function NoOpNameFilter(): NameFilter {
    return {
        groupFilter: () => true,
        clientFilter: () => true
    };
}

export function buildNameFilter(filter: string | null): NameFilter {
    if (filter == null || filter === "") {
        return NoOpNameFilter();
    } else {
        return {
            groupFilter: nameMatcher(filter),
            clientFilter: clientMatcher(filter)
        };
    }
}

function nameMatcher(filterVal: string): Predicate<RiskRow> {
    const matcher = new RegExp(escapeRegExp(filterVal.toLowerCase()), "i");
    return (rr) => {
        return matcher.test(rr.name);
    };
}

function clientMatcher(filterVal: string): Predicate<ClientRiskRow> {
    const matcher = new RegExp(`.*${escapeRegExp(filterVal.toLowerCase())}.*`, "i");
    return (rr) => {
        return matcher.test(rr.name) || matcher.test(rr.accountNumber);
    };
}
